import { put, PutEffect } from 'redux-saga/effects';
import { analyzeEvent } from 'b2b-apps/core/analytics/redux/tealium/actionCreators';
import { ANALYTICS_BOOLEAN, TEALIUM_INTERACTION_ID, TEALIUM_PROD_ACTION, TEALIUM_PROD_LIST } from 'b2b-apps/core/analytics/types/types';
import { prepareAnalyticsBool, preparePrice, prepareQuantity, prepareStock } from 'b2b-apps/core/analytics/utils/analytics';
import { OSS_INTERACTION_PARAMETERS } from '../search/types';
import { getSearchAnalyticsOssData } from '../search/utils';
import { InteractionData } from './types';

export function* analyzeProductsInteraction(
  interaction: TEALIUM_INTERACTION_ID,
  action: TEALIUM_PROD_ACTION | null,
  source: TEALIUM_PROD_LIST | null,
  interactionData: InteractionData,
): Generator<PutEffect, void> {
  const { products, search } = interactionData;

  yield put(analyzeEvent({
    interaction,
    prod: products.map(product => ({
      id: product.sku,
      categories: product.categories,
      price: preparePrice(product.price),
      stock: prepareStock(product.stock),
      ...(action && { action }),
      ...(product.listPosition != null && { pos: `${product.listPosition}` }),
      ...(source && { list: source }),
      ...(product.quantity != null && {
        quan: prepareQuantity(product.quantity),
        purchasable: prepareAnalyticsBool(product.isPurchasable),
        hasService: ANALYTICS_BOOLEAN.false,
      }),
    })),
    ...(search && {
      oss: getSearchAnalyticsOssData({
        ...OSS_INTERACTION_PARAMETERS[products[0].quantity != null
          ? TEALIUM_INTERACTION_ID.productSearchAddToCart
          : TEALIUM_INTERACTION_ID.productSearchListClick
        ],
        ...search,
      }),
    }),
  }));
}
